
module.exports.get_gradient = function get_gradient(canvas, color_one, color_two) {
  let gradient;
  const ctx = canvas.getContext('2d');
  gradient = ctx.createLinearGradient(0, 0, 0, 300);

  gradient.addColorStop(0, color_one);
  gradient.addColorStop(1, color_two);

  return gradient;
};
module.exports.getTextFromID = function getTextFromID(id) {
  let text;
  const jsonTexts = {
    p_rhb: 'rehabilitación pulmonar',
    p_seguimiento: 'seguimiento',
    no_registrado: 'sin registro',
    registrado: 'con registro',
  };
  text = jsonTexts[id];
  return text;
};

module.exports.getShortTextFromID = function getShortTextFromID(id) {
  let text;
  const jsonTexts = {
    p_rhb: 'RHB',
    p_seguimiento: 'Seguimiento',
    no_registrado: 'sin registro',
    registrado: 'con registro',
  };
  text = jsonTexts[id];
  return text;
};

module.exports.enviarMensajePacientes = function enviarMensajePacientes(mensaje) {
  const array_cedulas = [];
  let url_video;
  let url_audio;

  const { lista_pacientes } = mensaje;
  const { titulo_notificacion } = mensaje;
  const { asunto_notificacion } = mensaje;
  const audio_video = mensaje.audio_url;
  const { url } = mensaje;
  const { contenido_notificacion } = mensaje;

  let option = 'Ver chat';
  if (audio_video == 'video') {
    option = 'Ver video';
    url_video = url;
  } else if (audio_video == 'audio') {
    option = 'Escuchar audio';
    url_audio = url;
  }

  lista_pacientes.forEach((element) => {
    if (element.cedula != null) {
      array_cedulas.push({ valor: element.cedula });
    }
  });
  let json_envio = {
    tts: new Date().getTime(),
    notificaciones: {
      title: titulo_notificacion,
      body: asunto_notificacion,
    },
    datos: {
      codigo_de_agrupacion: `${titulo_notificacion}_${Date.now()}`,
      image_profile: 'https://firebasestorage.googleapis.com/v0/b/neumopush.appspot.com/o/app%2FDoctor%20Neumohdpi.png?alt=media&token=6003ea4a-d055-4de2-8a93-ac12f02d0ee7',
      name_from: 'Doctor Neumo',
      name_program: 'Médico general',
      notification: 'test desde chat',
      notification_option: option,
      notification_subject: titulo_notificacion,
      notification_video: url_video,
      notification_audio: url_audio,
    },
    token: array_cedulas,
    // topic:"news",
    sender: this.userlogged,
    recurrencia: 'instantanea',
    periodicidad: '21600000000',
  };
  // console.log(recorder)
  // this.$http.post('https://cd35f88d.ngrok.io', json_envio)

  this.$http.post('https://www.neumobot.com:5005', json_envio)
    .then((response) => {
      json_envio = {};
    })
    .catch((error) => {

    });
};

/**
* Funcion que convierte una cadena de caracteres con simbolos especiales en
* una cadena de caracteres sin estos simbolos para guardar el nombre del
* formulario de una mejor manera (tipo raw).
* Retorna un string sin caracteres especiales
* @param {*} nombre Cualquier palabra en su forma original (con simbolos especiales)
*/
module.exports.reemplazarCaracteresEspeciales = function reemplazarCaracteresEspeciales(nombre) { // nombreFormulario
  nombre = nombre.toLowerCase();
  nombre = nombre.replace((/\s/g), '_');
  nombre = nombre.replace((/[àáâãäå]/g), 'a');
  nombre = nombre.replace((/[èéêë]/g), 'e');
  nombre = nombre.replace((/[ìíîï]/g), 'i');
  nombre = nombre.replace((/[òóôõö]/g), 'o');
  nombre = nombre.replace((/[ùúûü]/g), 'u');
  nombre = nombre.replace((/ñ/g), 'n');
  nombre = nombre.replace((/[%/-]/g), '');
  nombre = nombre.replace(/\n/g, '');
  return nombre;
};



// WEBPACK FOOTER //
// ./src/js/metodos_comunes.js